

































import {Component, Prop, Vue} from 'vue-property-decorator';
import Cognito from "@/authorization/cognito";
import Translate from "@/consoleapi/api/translate";

@Component
export default class SignIn extends Vue {
    @Prop() private msg!: string;
    email: string | null = null;
    password: string | null = null;

    signIn(){
        const cognito = new Cognito();
        if(this.email === null || this.password === null){
            alert('必要な項目を入力してください。');
            return null;
        }
        cognito.signIn(this.email, this.password)
            .then(result => {
                this.$cookies.set(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN),result.getAccessToken().getJwtToken());
                this.$cookies.set(String(process.env.VUE_APP_COOKIE_REFRESH_TOKEN),result.getRefreshToken().getToken());
                this.$cookies.set(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME),result.getAccessToken().payload.username);
                window.location.href = String(process.env.VUE_APP_LOCATION_MAIN_PAGE);
            })
            .catch(err => {
                if(err.code === 'NotAuthorizedException') {
                    alert('メールアドレスとパスワードが一致しません。');
                    return;
                }
                this.translate(err.message || JSON.stringify(err));
       })
    }

    forfotPassword(){
        this.$router.push('forgot-password');
    }

    translate(message: string) {
        const translate = new Translate();
        translate.get(message)
            .then(response => {
                alert(response.data.text);
            })
            .catch(error => {
                //console.log(error.response);
                alert(message);
            })
    }

    signUp(){
        location.href = '/sign-up';
    }

    // パスワード表示トグル
    private isChecked?: boolean = false;

    get inputType(){
        return this.isChecked ? "text" : "password"
    }

    get iconType(){
        return this.isChecked ? "eye" : "eye-slash";
    }

    toggle(){
        this.isChecked = !this.isChecked;
    }
}

